import * as z from "zod";

import { issueSchema } from "./issue";
import { issueLinkSchema } from "./issue-link";

export const issueWithLinksSchema = issueSchema.extend({
  links: z.array(issueLinkSchema),
});

export type IssueWithLinks = z.infer<typeof issueWithLinksSchema>;
